import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Icms } from '../../components'
import * as icmsActionCreators from '../../redux/modules/icms'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class IcmsContainer extends Component {

  static propTypes = {
    history: PropTypes.object,
    multipleIcms: PropTypes.object,
    fetchMultipleIcms: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    destroyIcms: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    await this.props.fetchMultipleIcms()
  }

  handleRedirectToNew = () => {
    this.props.history.push('/icms/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/icms/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyIcms(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('icms', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('icms', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleIcms.toList().toJSON(),
      'icms',
      ['id', 'uf.sigla', 'classe_consumo.nome', 'aliquota'],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <Icms
        onRedirectToNew={this.handleRedirectToNew}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        multipleIcms={this.props.multipleIcms}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({ icms, status, sort, filter}) {
  const sortColumn = sort.getIn(['icms', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['icms', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['icms', 'filterText']) || ''

  let map = filterMap(icms, ['uf.nome', 'uf.sigla', 'classe_consumo.nome', 'aliquota'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleIcms: map,
    sortColumn,
    sortDirection,
    filterText,
    error: status.getIn(['icms', 'error']),
    isLoading: status.getIn(['icms', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...flashMessageAcionCreators,
    ...icmsActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(IcmsContainer)
